module.exports = __webpack_public_path__ + "static/media/TJ-payment.66d14af4.jpg";